import { render, staticRenderFns } from "./GridSubTable.vue?vue&type=template&id=32d8e980&scoped=true"
import script from "./GridSubTable.vue?vue&type=script&lang=js"
export * from "./GridSubTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d8e980",
  null
  
)

export default component.exports